import { QCONTENT_STATUS_TEXT } from '@exam-management/components';
import { QuestionStatus } from '@exam-management/graphql';
import { Tab, TabContext, TabList } from '@shared/components';

import { useQContentSearchParams } from '../../hooks';

interface TabItem {
  value: string;
  label: string;
}

const TAB_LIST: TabItem[] = [
  {
    value: '',
    label: 'All',
  },
  {
    value: QuestionStatus.Draft,
    label: QCONTENT_STATUS_TEXT[QuestionStatus.Draft],
  },
  {
    value: QuestionStatus.Published,
    label: QCONTENT_STATUS_TEXT[QuestionStatus.Published],
  },
  {
    value: QuestionStatus.Unpublished,
    label: QCONTENT_STATUS_TEXT[QuestionStatus.Unpublished],
  },
  {
    value: QuestionStatus.Disabled,
    label: QCONTENT_STATUS_TEXT[QuestionStatus.Disabled],
  },
  {
    value: QuestionStatus.PreDraft,
    label: QCONTENT_STATUS_TEXT[QuestionStatus.PreDraft],
  },
];

export default function QContentNavigationTabs() {
  const [{ status = '' }, setSearchParams] = useQContentSearchParams();

  const handleClick = (value: string) => {
    setSearchParams([
      { name: 'status', value },
      { name: 'page', value: 0 },
    ]);
  };

  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          gap: theme.spacing(0),
          px: theme.spacing(4),
          '& .MuiTabs-flexContainer': {
            gap: theme.spacing(0),
          },
        })}
      >
        {TAB_LIST.map((tab) => {
          return (
            <Tab
              sx={(theme) => ({
                borderRadius: theme.shape.rounded(0),
                p: theme.spacing(4, 4, 0, 4),
                minWidth: 'unset',
              })}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
